export enum Paths {
  home = '/',
  /** auth */
  login = '/login',
  references = '/references',
  referencesUser = '/references/:id',
  referencesUserArchive = '/references/archive/user:id',
  consultations = '/consultations',
  consultationsChat = '/consultations/:id',
  consultationsUserSubordination = '/consultations/user/subordination/:requestId',
  rvd = '/rvd',
  vacation = '/vacation',
  vacationApplication = '/vacation-application',
  vacationSchedule = '/vacation-schedule',
  reports = '/reports',
  controls = '/controls',
  vacationUser = '/vacation/user/:id',
  vacationUserSubordination = '/vacation/user/subordination/:requestId',
  absence = '/absence',
  absenceSupervisor = '/absence-supervisor',
  absenceUser = '/absence/:id',
  absenceUserArchive = '/absence/archive/user:id',
  substitutions = '/substitutions',
  news = '/news',
  faq = '/faq',
  overtime = '/overtime',
  polls = '/polls',
  dayoff = '/dayoff',
  dayoffUser = '/dayoffUser',
  cancelDayoff = '/cancelDayoff',
  vacationScheduleSubordinates = '/vacation-schedule-subordinates',
  dayoffSupervisor = '/dayoff-supervisor',
  dayoffCancelSupervisor = '/dayoff-cancel-supervisor',
}
